export const BuildInfo = {timestamp:1775587571000}
